import React, { useEffect, useState } from "react";
import styles from "./Menu.module.css";
import { useSatelightContext } from "../../provider/SatelightProvider";
import { SateliteData } from "../../mainLayer/satellite/SateLiteMenu";
import naturalEarth from "../../assets/natural_earth.jpg";
import osmDark from "../../assets/osm_dark.jpg";
import geographicProjection from "../../assets/geographic_projection.png";
import sphericalMercator from "../../assets/spherical_mercator.png";
import defaultImg from "../../assets/img.jpg";
import ImageLayer from "ol/layer/Image";
import { ImageWMS } from "ol/source";
import SatelliteLayers from "../../mainLayer/satellite/SatelliteLayers";

type MenuItemPropType = {
  id: string;
  title: string;
  timeLineHour: string;
  timeLineDate: string;
};

const getImageById = (id: string) => {
  const images: Record<string, string> = {
    verit06: naturalEarth,
    verit03: osmDark,
    verit02: geographicProjection,
    sdsf: sphericalMercator,
  };

  return images[id] || defaultImg;
};

let selectSatellightId: string = "";
let selectDay: string = "";
let selectTime: string = "";
let removeId: string = "";
let isRemoved: boolean = false;

const SatelliteImageryItem = ({
  id,
  title,
  timeLineHour,
  timeLineDate,
}: MenuItemPropType) => {

  const { receivedSatelliteTime,isMinEyeClickSatelight,openSatelightList,satelightListOpen,setIsSatelightClickProvider,isSatelightClickProvider } = useSatelightContext();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const activeSatelliteIds = new Set<string>();

  useEffect(() => {
    if(isSatelightClickProvider==="clickSatellite"){
      loadSatelliteImages(selectSatellightId);

      // if((selectDay !== timeLineDate) && (selectTime !== timeLineHour) ){
      //   console.log("______",timeLineHour,"__________",timeLineDate)
      //   loadSatelliteImages(selectSatellightId);
      // }else if(selectSatellightId !==setId){
      //       console.log("========here============")
      //   loadSatelliteImages(selectSatellightId);
      // }
    }
  }, [timeLineHour, timeLineDate, selectSatellightId]);

  useEffect(() => {
    if(!isMinEyeClickSatelight){
      loadSatelliteImages(selectSatellightId);
    }
  }, [isMinEyeClickSatelight]);

  const selectSat = async (id: string) => {
    selectSatellightId = id;

    setSelectedId((prevId) => (prevId === id ? null : id));

    const isCurrentlyOpen = openSatelightList.get(id) || false;
    if(isCurrentlyOpen){
      removeId=id;
      isRemoved=true;
    }else{
      isRemoved=false;
    }

    satelightListOpen(id, !isCurrentlyOpen);
    setIsSatelightClickProvider("clickSatellite")

    const satellite = [
      "2025-01-09 13:22:44zzutc",
        "2025-01-08 12:43:44zzutc",
        "2025-01-10 00:35:44zzutc",
        "2025-01-10 02:33:44zzutc",
        "2025-01-10 04:15:44zzutc"
    ];
    
    receivedSatelliteTime(satellite);

    // try {
    //   const response = await fetch(
    //     "https://mobile.mobilise-project.org.uk/mobisense/air/sensors/getreadings"+id
    //   );
    //   const responseData = await response.json();

    //   if (responseData && Array.isArray(responseData.satellite)) {
    //     const data: string[] = responseData.satellite;

    //         const  satellite= [
    //           "2025-01-09 13:22:44zzutc",
    //           "2025-01-08 12:22:44zzutc",
    //           "2025-01-10 00:22:44zzutc",
    //           "2025-01-10 02:22:44zzutc",
    //           "2025-01-10 04:22:44zzutc"
    //         ]
    //
    //   receivedSatelliteTime(satellite)
    //     console.log("Satellite Data:", data);
    //   } else {
    //     console.error("Invalid response data format:", responseData);
    //   }
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // }
    loadSatelliteImages(selectSatellightId);
  };

  useEffect(() => {}, [selectSatellightId]);
  useEffect(() => {}, [removeId]);
  useEffect(() => {}, [isRemoved]);

  const loadSatelliteImages = async (selectId: string) => {
    // selectDay=timeLineDate;
    // selectTime=timeLineHour;

     console.log("---ww---", removeId, "--", selectId, "--", selectSatellightId);
    try {
      var layers = new ImageLayer({
        source: new ImageWMS({
          url: "https://wms.tecxal.com/visura/weatherwmseagle",
          params: {
            LAYERS: `weather:${selectId}_icon_${timeLineDate}-${timeLineHour}:00_temp`,
            STYLES: "weather:icontemp",
          },
          serverType: "geoserver",
          projection: "EPSG:4326",
        }),
      });
      layers.set("name", `satellite_${selectId}`);
      // allWeatherMapICON("tempMapIcon", tempMapIcon);
      if (layers) {
        if(!isMinEyeClickSatelight){
          SatelliteLayers(layers, true, "satellite_"+selectId);
        }else if(isRemoved===true){
          SatelliteLayers(layers, true, "satellite_"+selectId);
        }else{
          SatelliteLayers(layers, false, "satellite_"+selectId);
        }
      }
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };
  
  const setName=(title:string)=>{
if(title==="Batticaloa"){
  return "MTG-0 Degree";
}else if(title==="Hambantota"){
  return "MSG-IODC";
}else if(title==="Monaragala"){
  return "MSG-RSS";
}else if(title==="Kandy"){
  return "Sentinel 3A";
}else if(title==="Polonnaruwa"){
  return "Sentinel 3B";
}else if(title==="Kurunegala"){
  return "Metop c";
}
  }

  return (
    <div
      key={id}
      className={styles.basecampItem}
      onClick={() => {
        selectSat(id);
      }}
      onTouchStart={() => {
        selectSat(id);
      }}
    >
      <span>{setName(title)}</span>
      <img src={getImageById(id)} alt="" style={{  border: selectedId === id ?"2px solid var(--leftside-button-bg-color)": "0px ", borderRadius: "5px" , width: '5rem', height: '3rem'}}/>
    </div>
  );
};

export default SatelliteImageryItem;
